import React from 'react'
import { formatDecimalHoursToHM } from '../../utils/formatDecimalHoursToHM'
import { TfiTime } from 'react-icons/tfi'
import { IoSettingsOutline } from 'react-icons/io5'

export const StampMethodRow = (
  {
    methodData
  }
) => {

  const {
    name,
    drawingQuantity,
    drawingStamps,
    drawingTotalStampsByHourlyRate,
    drawingTotalPrepareTime,
    drawingPrepareOperationsCount
  } = methodData

  const formatHours = formatDecimalHoursToHM(drawingTotalStampsByHourlyRate)
  const totalPrepareTime = formatDecimalHoursToHM(drawingTotalPrepareTime)

  return (
    <div className={`grid grid-cols-[72rem_1fr_1fr] mt-[1px] font-medium text-gray-700 text-Regular(14_16) gap-[1px]`}>
      <div className='py-[2.2rem] bg-[#E1CCE7] text-left pl-[4rem]'>
        {name}
      </div>
      <div className={`py-[2.2rem] bg-[#ffffff] text-center grid grid-cols-[1fr_2fr] gap-[3rem]`}>
        <div className={`flex justify-end`}>
          {drawingQuantity ? drawingStamps.toLocaleString() : '-'}
        </div>
        {formatHours && <div className={`flex items-center gap-[2rem]`}>
          <div className={`flex items-center gap-[0.4rem]`}>
            <TfiTime /> {formatHours}
          </div>
          {(drawingQuantity && totalPrepareTime) ? <div className={`flex items-center gap-[0.4rem]`}>
            <IoSettingsOutline/> {totalPrepareTime} ({drawingPrepareOperationsCount} настр.)
          </div>
            : <div className={`flex items-center gap-[0.4rem]`}>-</div>
          }
        </div>
        }
      </div>
      <div
        className={`py-[2.2rem] bg-[#ffffff] text-center`}>{drawingQuantity ? drawingQuantity.toLocaleString() : '-'}</div>
    </div>
  )
}